/**
 * 営業設定 > 業務メールテンプレートタブ。
 * v3.1.4 — 旧 /mail/business-templates ページから本タブへ移管。
 *
 * 既存の BusinessMailTemplatesPage UI をそのまま埋め込む。Screen ラッパは
 * SalesSettingsPage 側で持つため、ここでは中身のみを描画する。
 */
import { BusinessMailTemplatesContent } from '@/pages/business-mail-templates/BusinessMailTemplatesPage';

export function MailTemplatesTab() {
  return <BusinessMailTemplatesContent />;
}
